/**
 * Console utility that disables console logs in production to improve performance
 * 
 * Usage:
 *   import { log, warn, debug } from '../utils/console';
 *   log('Message', data); // Only logs in development
 */

const isDevelopment = process.env.NODE_ENV === 'development';

// Override console methods in production to prevent performance impact
// This is especially important when DevTools are open, as console operations
// can be 10-100x slower
export const log = (...args: any[]) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const warn = (...args: any[]) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

export const debug = (...args: any[]) => {
  if (isDevelopment) {
    console.debug(...args);
  }
};

export const info = (...args: any[]) => {
  if (isDevelopment) {
    console.info(...args);
  }
};

// Error should always be logged (for critical debugging)
export const error = (...args: any[]) => {
  console.error(...args);
};

// Export a default object for convenience
export default {
  log,
  warn,
  debug,
  info,
  error,
};

// Export environment info for debugging (only in development)
// This allows checking the environment in browser console
if (typeof window !== 'undefined') {
  (window as any).__ENV_INFO__ = {
    NODE_ENV: isDevelopment ? 'development' : 'production',
    isDevelopment,
    // Helper to test if logging is enabled
    testLogging: () => {
      console.log('=== Logging Test ===');
      log('This is a log message (should only appear in development)');
      warn('This is a warn message (should only appear in development)');
      debug('This is a debug message (should only appear in development)');
      error('This is an error message (should always appear)');
      console.log('=== End Logging Test ===');
    }
  };
}

